export default __webpack_public_path__ + "static/media/pin-v-2.6b4107b0.svg";